import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCalendarEmpty: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3.125H13.9583V2.5C13.9583 2.155 13.6783 1.875 13.3333 1.875C12.9883 1.875 12.7083 2.155 12.7083 2.5V3.125H7.29167V2.5C7.29167 2.155 7.01167 1.875 6.66667 1.875C6.32167 1.875 6.04167 2.155 6.04167 2.5V3.125H5C2.985 3.125 1.875 4.235 1.875 6.25V15C1.875 17.015 2.985 18.125 5 18.125H15C17.015 18.125 18.125 17.015 18.125 15V6.25C18.125 4.235 17.015 3.125 15 3.125ZM5 4.375H6.04167V5C6.04167 5.345 6.32167 5.625 6.66667 5.625C7.01167 5.625 7.29167 5.345 7.29167 5V4.375H12.7083V5C12.7083 5.345 12.9883 5.625 13.3333 5.625C13.6783 5.625 13.9583 5.345 13.9583 5V4.375H15C16.3142 4.375 16.875 4.93583 16.875 6.25V6.875H3.125V6.25C3.125 4.93583 3.68583 4.375 5 4.375ZM15 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V8.125H16.875V15C16.875 16.3142 16.3142 16.875 15 16.875Z"
      fill={color}
    />
  </svg>
);

export default IconCalendarEmpty;
